import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail, Ruler, Truck, Paintbrush, Check, ArrowUpRight } from "lucide-react";

// Hire inventory — add new items here
const hireItems = [
  {
    id: "boombox",
    name: "THE MT. LOOP BOOMBOX",
    tagline: "ONE BUILD. ENDLESS LOOKS.",
    description: "Large-scale customisable scenic piece available for hire.",
    perfectFor: [
      "Christmas events",
      "Brand activations",
      "Festivals",
      "Nightlife",
      "Corporate events",
      "Photo opportunities",
      "Product launches",
      "Immersive experiences"
    ],
    size: "Approx 4.8m Wide × 2.4m High × 2.4m Deep",
    customise: ["Colour", "Graphics", "Branding", "Lighting", "Theme"],
    availableAs: "Wet hire — delivery, installation & collection by Mt. Loop.",
    caseStudyLink: "/behind-the-builds#the-boombox",
    images: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/durrg3r2_Christmas%20Boombox.png",
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/i8adfww4_Boom%20Box%20Blue.webp",
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/tze6fc8h_Boom%20Box%20Red.webp"
    ]
  },
  {
    id: "character-dj-booth",
    name: "THE CHARACTER DJ BOOTH",
    tagline: "A DJ BOOTH WITH A LITTLE MORE PERSONALITY.",
    description: "A large-scale character DJ booth designed to make the performance area part of the experience. Originally created as a bespoke scenic piece for an immersive Halloween event, the booth combines a fully functioning DJ position with a bold, oversized character design — making it a natural focal point for parties, festivals, club nights and branded experiences.",
    makeItYours: [
      "The character can be customised for your event or brand, including branding and artwork applied directly to the face.",
      "Change the look, add campaign graphics, incorporate your brand or give it an entirely different personality. We can work with your creative direction to make the piece fit your event."
    ],
    perfectFor: [
      "Halloween & themed events",
      "Club nights & parties",
      "Festivals",
      "Brand activations",
      "Product launches",
      "Immersive experiences",
      "Corporate events",
      "Photo & social-media moments"
    ],
    size: "Approx 2m Long × 1.2m Wide",
    availableAs: "Wet hire available — Mt. Loop handles delivery, installation and collection.",
    caseStudyLink: "/behind-the-builds#fever-dream",
    images: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/jyge14dm_Labu1.png",
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/nb3p8vgc_DJ%20Booth.png"
    ]
  },
  {
    id: "entrance-door-surround",
    name: "CHARACTER ENTRANCE DOOR SURROUND",
    tagline: "MAKE AN ENTRANCE.",
    description: "A large-scale character entrance designed to turn an ordinary doorway into a full-blown event feature. Standing at approximately 4.2m high and 1.9m wide, the character surrounds the entrance and creates an instant focal point for guests as they arrive. Originally created as part of a bespoke Halloween installation, it works particularly well for Halloween events, club nights, festivals, immersive experiences, brand activations and themed venues.",
    makeItYours: [
      "The character can be customised to suit your event or brand, including artwork, colours, graphics and branding applied to the character itself.",
      "Whether you want something dark and sinister, completely on-brand or something totally unexpected, we can adapt the finish to fit the brief."
    ],
    perfectFor: [
      "Halloween & themed events",
      "Club nights & parties",
      "Festivals",
      "Brand activations",
      "Immersive experiences",
      "Venue entrances",
      "Corporate events",
      "Photo & social-media moments"
    ],
    size: "Approx 4.2m High × 1.9m Wide",
    availableAs: "Wet hire only — Mt. Loop handles delivery, installation and collection.",
    caseStudyLink: "/behind-the-builds#fever-dream",
    images: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/9dl9pgz4_Door%20Surround.png",
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/i3grar52_Labu3.png"
    ]
  },
  {
    id: "heart-photo-op",
    name: "THE HEART PHOTO OP",
    tagline: "A LITTLE LOVE GOES A LONG WAY.",
    description: "A striking oversized heart photo opportunity, designed to create an instant backdrop and memorable moment at events. Available in the signature pink finish shown, or fully customisable with a different fabric colour to suit your event, brand or colour palette.",
    makeItYours: [
      "Choose the pink finish as shown, or work with us to create a different look using your own event colours or branding.",
      "The fabric finish can be adapted to suit the overall aesthetic of your event, making it easy to turn the same scenic piece into something completely different.",
      "And if you need a photo opportunity that's completely unique to your event, we can design and fabricate that too."
    ],
    perfectFor: [
      "Weddings & celebrations",
      "Parties",
      "Brand activations",
      "Product launches",
      "Corporate events",
      "Festivals",
      "Immersive experiences",
      "Red carpet & photo opportunities"
    ],
    size: "Approx 2.4m × 2.4m",
    availableAs: "Available for hire — with delivery, installation and collection handled by Mt. Loop.",
    closing: "BIG HEART. BIG PHOTO MOMENT.",
    images: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/rmcj0va8_Pink%20Heart%20Photo%20Op.png",
      "https://customer-assets-0z36b82j.emergentagent.net/job_78cdb6a7-1fac-4a3c-9b03-735d8ee52d6a/artifacts/4yh9qnzi_Black%20heart%20photo%20op.png"
    ]
  }
];

const HireItemGallery = ({ item }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <div>
      <div className="relative">
        <div className="absolute -top-4 -left-4 w-full h-full border-2 border-[#007e7a]/30" />
        <div className="relative h-[340px] sm:h-[440px] lg:h-[520px] overflow-hidden bg-[#174c4f]/5">
          <img
            src={item.images[activeIndex]}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover blur-2xl scale-110 opacity-50"
          />
          <motion.img
            key={activeIndex}
            src={item.images[activeIndex]}
            alt={item.name}
            className="relative w-full h-full object-contain"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            data-testid={`hire-${item.id}-main-image`}
          />
        </div>
        <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-[#ffd6a5]/30" />
      </div>
      <div className="flex gap-3 mt-8">
        {item.images.map((img, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            data-testid={`hire-${item.id}-thumb-${index}`}
            className={`relative w-20 h-20 sm:w-24 sm:h-24 overflow-hidden transition-all ${
              index === activeIndex
                ? "ring-2 ring-[#007e7a] ring-offset-2 ring-offset-[#e8f9f7]"
                : "opacity-60 hover:opacity-100"
            }`}
          >
            <img src={img} alt={`${item.name} view ${index + 1}`} className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};

const HireItem = ({ item, index }) => {
  const mailto = `mailto:LAURA@MTLOOP.CO.UK?subject=${encodeURIComponent(`Hire Enquiry: ${item.name}`)}`;
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className={`grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center ${
        index % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
      }`}
      data-testid={`hire-item-${item.id}`}
    >
      <HireItemGallery item={item} />

      <div>
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-[2px] bg-[#007e7a]" />
          <span className="tech-label">Available For Hire</span>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#174c4f] leading-tight mb-3" data-testid={`hire-${item.id}-title`}>
          {item.name}
        </h2>
        <p className="text-lg md:text-xl font-semibold text-[#007e7a] tracking-[0.08em] mb-6" data-testid={`hire-${item.id}-tagline`}>
          {item.tagline}
        </p>

        <p className="text-base md:text-lg text-[#789994] leading-relaxed mb-8">{item.description}</p>

        {item.makeItYours && (
          <div className="mb-8" data-testid={`hire-${item.id}-make-it-yours`}>
            <h3 className="text-xs uppercase tracking-[0.25em] text-[#174c4f] font-semibold mb-4">Make It Yours</h3>
            {item.makeItYours.map((para, i) => (
              <p key={i} className="text-sm md:text-base text-[#789994] leading-relaxed mb-3">{para}</p>
            ))}
          </div>
        )}

        <div className="mb-8">
          <h3 className="text-xs uppercase tracking-[0.25em] text-[#174c4f] font-semibold mb-4">Perfect For</h3>
          <div className="grid grid-cols-2 gap-x-6 gap-y-3">
            {item.perfectFor.map((use) => (
              <div key={use} className="flex items-center gap-2 text-sm md:text-base text-[#174c4f]">
                <Check size={16} className="text-[#007e7a] flex-shrink-0" />
                {use}
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-4 mb-10 border-l-2 border-[#ffd6a5] pl-6">
          <div className="flex items-start gap-3">
            <Ruler size={18} className="text-[#007e7a] mt-1 flex-shrink-0" />
            <p className="text-sm md:text-base text-[#174c4f]">{item.size}</p>
          </div>
          {item.customise && (
            <div className="flex items-start gap-3">
              <Paintbrush size={18} className="text-[#007e7a] mt-1 flex-shrink-0" />
              <p className="text-sm md:text-base text-[#174c4f]">
                <span className="font-semibold">Customise it:</span> {item.customise.join(" • ")}
              </p>
            </div>
          )}
          <div className="flex items-start gap-3">
            <Truck size={18} className="text-[#007e7a] mt-1 flex-shrink-0" />
            <p className="text-sm md:text-base text-[#174c4f]">
              <span className="font-semibold">Available as:</span> {item.availableAs}
            </p>
          </div>
        </div>

        {item.closing && (
          <p className="text-lg md:text-xl font-bold text-[#174c4f] tracking-[0.08em] mb-8" data-testid={`hire-${item.id}-closing`}>
            {item.closing}
          </p>
        )}

        <div className="flex flex-col sm:flex-row flex-wrap gap-4">
          <a
            href={mailto}
            className="btn-primary inline-flex items-center justify-center gap-3"
            data-testid={`hire-${item.id}-enquire-btn`}
          >
            <Mail size={18} /> Hire This Piece
          </a>
          {item.caseStudyLink && (
            <Link
              to={item.caseStudyLink}
              className="btn-secondary inline-flex items-center justify-center gap-3"
              data-testid={`hire-${item.id}-story-link`}
            >
              Read The Full Build Story <ArrowUpRight size={18} />
            </Link>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default function HirePage() {
  return (
    <div data-testid="hire-page" className="pattern-bg">
      {/* Page Header */}
      <section className="pt-40 pb-20 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-[2px] bg-[#007e7a]" />
              <span className="tech-label">For Hire</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#174c4f] leading-[0.95] mb-8" data-testid="hire-page-title">
              Statement Pieces,
              <br />
              <span className="text-[#007e7a]">Ready To Hire</span>
            </h1>
            <p className="text-base md:text-lg text-[#789994] max-w-2xl leading-relaxed">
              Show-stopping scenic builds available for your next event — fully customisable,
              delivered and installed by the MT.LOOP team.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Hire Items */}
      <section className="pb-28 md:pb-36 px-6 md:px-12">
        <div className="max-w-7xl mx-auto space-y-32">
          {hireItems.map((item, index) => (
            <HireItem key={item.id} item={item} index={index} />
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-6 md:px-12 bg-[#174c4f]" data-testid="hire-cta-section">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-base md:text-lg font-semibold text-[#ffd6a5] uppercase tracking-[0.2em] mb-4">
            Something Specific In Mind?
          </h2>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
            Every piece can be re-themed, re-branded and re-lit to match your event.
            Tell us your idea and we'll make it happen.
          </p>
          <a
            href="mailto:LAURA@MTLOOP.CO.UK?subject=Hire%20Enquiry"
            className="btn-primary inline-flex items-center justify-center gap-3"
            data-testid="hire-cta-email-btn"
          >
            <Mail size={18} /> LAURA@MTLOOP.CO.UK
          </a>
        </div>
      </section>
    </div>
  );
}
